// REGULAR STRINGIFIED COLORS
export const WHITE = 'white';
export const BLACK = 'black';
export const TRANSPARENT = 'transparent';
export const RED = 'red';

// SPECIFIC COLORS FROM DESIGN
export const DEFAULT_HEADER_BACKGROUND_COLOR = '#110e4c';
export const DEFAULT_FOOTER_BACKGROUND_COLOR = WHITE;
export const DEFAULT_TABS_BACKGROUND_COLOR = WHITE;
export const DEFAULT_BLUE_BUTTON_BACKGROUND_COLOR = '#4b7be5';
export const DEFAULT_GRAY_BUTTON_BACKGROUND_COLOR = WHITE;
export const DEFAULT_GRAY_BUTTON_TEXT_COLOR = '#3f3c70';
export const DEFAULT_BUTTON_BOX_SHADOW_RGBA = 'rgba(75, 123, 229, 0.5)';
export const DEFAULT_SECONDARY_BUTTON_BOX_SHADOW_RGBA = 'rgba(75, 123, 229, 0.1)';
export const DEFAULT_MAIN_SECTION_BACKGROUND_COLOR = '#f8f7ff';
export const DEFAULT_FOOTER_FONT_COLOR = '#6d6a94';
export const DEFAULT_SKIP_FONT_COLOR = '#6d6a94';
export const DEFAULT_UNSELECTED_TAB_COLOR = '#6d6a94';
export const DEFAULT_SELECTED_TAB_COLOR = '#4b7be5';
export const DEFAULT_TITLE_COLOR = '#110e4c';
export const DEFAULT_STEP_ICON_BACKGROUND_COLOR = 'rgb(17 14 76 / 10%)';
export const DEFAULT_STEP_ICON_FONT_COLOR = 'rgb(17 14 76 / 30%)';
export const DEFAULT_COMPLETE_STEP_ICON_FONT_COLOR = '#4b7be5';
export const DEFAULT_ADDRESS_INPUT_BACKGROUND_COLOR = 'rgba(17 14 76 / 5%)';
export const DEFAULT_SPINNER_COLOR = '#4b7be5';
export const DEFAULT_VERTICAL_DIVIDER_COLOR = 'rgba(17 14 76 / 20%)';
export const DEFAULT_COST_INPUT_BORDER_COLOR = 'rgba(75 123 229 / 40%)';
export const DEFAULT_COST_INPUT_BACKGROUND_COLOR = '#edecf6';
export const DEFAULT_CONNECTION_INFORMATION_BACKGROUND_COLOR = '#4b7be5';
export const DEFAULT_CONNECTION_INFORMATION_VERTICAL_DIVIDER_COLOR = 'rgba(255 255 255 / 15%)';
export const DEFAULT_CONNECTION_INFORMATION_BOX_SHADOW = '0 4px 15px -2px rgba(75, 123, 229, 0.3)'
export const DEFAULT_STATS_TABLE_BOX_SHADOW_RGBA = 'rgba(17, 14, 76, 0.05)';
export const DEFAULT_STATS_TABLE_TEXT_COLOR = '#6d6a94';
export const DEFAULT_STATS_TABLE_VERTICAL_DIVIDER_COLOR = 'rgba(160 159 183 / 30%)';
export const DEFAULT_SPEED_TEST_PROGRESS_BAR_COLOR = 'rgba(17 14 76 / 50%)';
export const DEFAULT_ERROR_SNACKBAR_BACKGROUND_COLOR = 'rgba(196 29 82 / 10%)';
export const DEFAULT_ERROR_SNACKBAR_FONT_COLOR = '#c41d52';
export const DEFAULT_WARNING_SNACKBAR_BACKGROUND_COLOR = 'rgba(255 196 77 / 30%)';
export const DEFAULT_WARNING_SNACKBAR_FONT_COLOR = '#a7781a';
export const DEFAULT_MAP_MODAL_BACKGROUND_COLOR = '#f8f7ff';
export const DEFAULT_EXPLORE_AREA_COLOR = '#4b7be5';
export const DEFAULT_STEP_CONNECTOR_COLOR = '#e1dfee';
export const DEFAULT_SPEED_FILTER_BACKGROUND_COLOR = 'rgba(17 14 76 / 90%)';
export const DEFAULT_SPEED_FILTER_BOX_SHADOW = 'rgba(17 14 76 / 40%)';
export const DEFAULT_FILTERS_SUBTITLE_COLOR = '#a09fb7';
export const DEFAULT_FILTERS_TABS_BACKGROUND_COLOR = 'rgba(17 14 76 / 85%)';
export const DEFAULT_SELECTED_FILTER_TAB_COLOR = '#4b7be5';
export const DEFAULT_DOWNLOAD_FILTER_NONE = '#a09fb7'
export const DEFAULT_DOWNLOAD_FILTER_LOW = '#f8aa6b';
export const DEFAULT_DOWNLOAD_FILTER_MID = '#ce5db8';
export const DEFAULT_DOWNLOAD_FILTER_HIGH = '#6e48ca';
export const DEFAULT_FILTER_BULLET_OUTLINE_COLOR = 'rgba(160 159 183 / 55%)';
export const DEFAULT_FILTER_ACTIVE_COUNT_COLOR = '#4b7be5';
export const DEFAULT_MAP_POPUP_HEADER_BACKGROUND_COLOR = '#f8f7ff';
export const DEFAULT_MAP_POPUP_FOOTER_BACKGROUND_COLOR = 'rgba(239 244 255 / 20%)';
export const DEFAULT_MAP_POPUP_ADDRESS_TITLE_COLOR = '#110e4c';
export const DEFAULT_MAP_POPUP_ADDRESS_SUBTITLE_COLOR = '#3f3c70';
export const DEFAULT_POPUP_TITLE_COLOR = '#6d6a94';
export const DEFAULT_POPUP_VALUE_COLOR = '#110e4c';
export const DEFAULT_MAP_LEFT_ARROW_BORDER_COLOR = 'solid 1px rgba(17 14 76 / 35%)';
export const DEFAULT_HISTORICAL_VALUES_HEADER_TITLE_COLOR = '#6d6a94';
export const HISTORICAL_VALUES_TABLE_ROW_EVEN_BG_COLOR = 'rgba(17 14 76 / 5%)';
export const HISTORICAL_VALUES_TABLE_ROW_DARK_VALUES_COLOR = '#110e4c';
export const DEFAULT_PAGE_SELECTED_COLOR = '#4b7be5';
export const DEFAULT_PAGE_COLOR = '#6d6a94';
export const DEFAULT_HORIZONTAL_DIVIDER_BG_COLOR = 'rgba(255 255 255 / 20%)';
export const DEFAULT_FOOTER_HORIZONTAL_DIVIDER_BG_COLOR = 'rgba(160 159 183 / 20%)';
export const DEFAULT_VERTICAL_OPTION_DIVIDER_COLOR = 'rgba(17 14 76 / 20%)';
export const DEFAULT_MODAL_INFO_TABLE_COLOR = 'rgba(75 123 229 / 15%)';
export const DEFAULT_CIRCULAR_ICON_BG_COLOR = 'rgba(75 123 229 / 20%)';
export const DEFAULT_TEXT_COLOR = '#3f3c70';
export const DEFAULT_LINK_COLOR = '#6d6a94';
export const DEFAULT_MODAL_BOX_SHADOW = 'rgba(17, 14, 76, 10%)'
export const DATA_COLUMN_ICON_CONTAINER = 'rgba(75, 123, 229, 0.15)';
export const DEFAULT_SECONDARY_TEXT = '#3F3C70';
export const FLOATING_MESSAGE_BOX = 'rgba(255, 255, 255, 0.85)';
export const FLOATING_MESSAGE_BOX_SHADOW = 'rgba(0, 0, 0, 0.4)';
export const FOOTER_BOX_SHADOW = DEFAULT_ADDRESS_INPUT_BACKGROUND_COLOR;
export const WIDGET_STATS_BG_COLOR = '#F3F3F7';
export const WIDGET_SECONDARY_BUTTON_BG_COLOR = 'rgba(122, 121, 146, 0.1)';
export const WIDGET_SECONDARY_BUTTON_COLOR = DEFAULT_GRAY_BUTTON_TEXT_COLOR;
export const WIDGET_SECONDARY_BUTTON_BOX_SHADOW = 'rgba(122, 121, 146, 0.05)';
export const WIDGET_MODAL_BOX_SHADOW = 'rgba(17, 14, 76, 0.05)';
export const WIDGET_MODAL_OUTLINE = 'rgba(109, 106, 148, 0.1)';

// NEW MAP STYLES
export const NEW_SPEED_HIGH = 'rgba(49, 179, 108, 0.9)';
export const NEW_SPEED_MEDIUM = 'rgba(246, 171, 82, 0.9)';
export const NEW_SPEED_LOW = 'rgba(229, 75, 75, 0.9)';